// extracted by mini-css-extract-plugin
export default {"root":"OpenEcg_root__Itmw0","gridPanel":"OpenEcg_gridPanel__H1Shy","uploadContainer":"OpenEcg_uploadContainer__fj+rr"};